function injectFormStylesAndButton() {
  const container = document.querySelector('[data-forms-id]');

  if (!container) {
    requestAnimationFrame(injectFormStylesAndButton);
    return;
  }

  let stylesApplied = false;
  let buttonAdded = false;

  const applyStyles = (shadowRoot) => {
    if (stylesApplied || !shadowRoot || shadowRoot.querySelector('#custom-form-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'custom-form-styles';
    style.textContent = `
      #form-container-ref button[type="submit"],
      #form-container-ref #additional-button {
        background-image: linear-gradient(#f59bbb, #f59bbb), linear-gradient(45deg, #7b6ae0, #ffbb89);
        background-origin: border-box;
        background-clip: padding-box, border-box;
        border: 1px solid transparent;
        border-radius: 50em;
        font-weight: 600;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-height: 48px;
        box-sizing: border-box;
        padding: 5px 15px;
        width: calc(50% - 8px);
      }

      #form-container-ref #additional-button {
        text-decoration: none;
        color: #414651;
        background-image: linear-gradient(#fff, #fff), linear-gradient(45deg, #7b6ae0, #ffbb89);
        font-size: 16px;
      }

      #form-container-ref #additional-button:hover {
        background-color: #fafafa;
        background-image: linear-gradient(#fafafa, #fafafa), linear-gradient(45deg, #7b6ae0, #ffbb89);
        box-shadow: 0 2px 4px #0000001a;
      }

      #form-container-ref button[type="submit"]:hover {
        background-color: #a7697f;
        background-image: linear-gradient(#a7697f, #a7697f), linear-gradient(45deg, #7b6ae0, #ffbb89);
        box-shadow: 0 2px 4px #0000001a;
      }

      #form-container-ref ._formFieldContainer_1mxsl_5 {
        position: relative !important;
      }

      #form-container-ref .phone-country-selector button:before,
      #form-container-ref ._formFieldContainer_1mxsl_5:after {
        content: "";
        position: absolute;
        top: -1px;
        left: -1px;
        width: calc(100% + 2px);
        height: calc(100% + 2px);
        background: linear-gradient(45deg, #7b6ae0, #ffbb89);
        border-radius: 8px;
        z-index: 0;
        pointer-events: none;
      }

      #form-container-ref .phone-country-selector button:before {
        width: 92px;
        z-index: -1;
      }

      #form-container-ref .phone-country-selector button,
      #form-container-ref ._formFieldContainer_1mxsl_5 textarea,
      #form-container-ref ._formFieldContainer_1mxsl_5 input {
        position: relative;
        z-index: 1;
        min-height: 49.2px;
        background-color: #fff;
        box-sizing: border-box;
        border: none !important;
        box-shadow: none !important;
      }

      #form-container-ref .phone-country-selector button {
        max-height: 49.2px;
      }

      #form-container-ref .phone-country-selector button:before {
        max-height: 51.2px;
      }

      [data-testid="banner-success"] h2 {
        font-weight: 700 !important;
        font-size: 36px !important;
        line-height: 44px !important;
        color: #181d27 !important;
        margin-bottom: 16px !important;
      }

      [data-testid="banner-success"] p {
        font-weight: 400 !important;
        font-size: 18px !important;
        line-height: 24px !important;
        color: #535862 !important;
      }

      @media (min-width: 750px) {
        [data-testid="banner-success"] p {
          font-size: 20px !important;
          line-height: 26px !important;
        }
      }

      #form-container-ref .form-buttons-wrapper {
        display: flex;
        gap: 16px;
      }
    `;

    shadowRoot.appendChild(style);
    stylesApplied = true;
  };

  const injectAdditionalButton = (shadowRoot) => {
    if (buttonAdded || !shadowRoot || shadowRoot.querySelector('#additional-button')) {
      return;
    }

    const submitButton = shadowRoot.querySelector('#form-container-ref button[type="submit"]');
    if (!submitButton) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'form-buttons-wrapper';

    submitButton.parentNode.insertBefore(wrapper, submitButton);

    const buttonEl = `<a id="additional-button" class="button " href="/collections/curated-collection">shop cupcakes</a>`;
    wrapper.insertAdjacentHTML('beforeend', buttonEl);

    wrapper.appendChild(submitButton);
    buttonAdded = true;
  };

  function watchShopifyForm(shadowRoot) {
    if (!shadowRoot) return;

    const innerForm = shadowRoot.querySelector('form');
    if (!innerForm) return;

    // Track if form is being submitted
    let isSubmitting = false;

    innerForm.addEventListener('submit', (e) => {
      isSubmitting = true;
    });

    const formObserver = new MutationObserver((mutations) => {
      const successBanner = shadowRoot.querySelector('[data-testid="banner-success"]');
      
      if (successBanner && isSubmitting) {        
        // Get specific form fields by ID
        const fullnameInput = innerForm.querySelector('[id="custom#fullname"]');
        const emailInput = innerForm.querySelector('#email');
        const phoneInput = innerForm.querySelector('#phone_number');
        const peopleInput = innerForm.querySelector('[id="custom#number_of_people"]');
        const quantityInput = innerForm.querySelector('[id="custom#quantity_of_cupcakes_needed"]');
        const notesInput = innerForm.querySelector('[name="custom#notes"]');
        
        const data = {
          "fullname": fullnameInput?.value || '',
          "customer_email": emailInput?.value || '',
          "phone_number": phoneInput?.value || '',
          "number_of_people": peopleInput?.value || '',
          "quantity_of_cupcakes_needed": quantityInput?.value || '',
          "notes": notesInput?.value || ''
        };

        // Send to Klaviyo
        if (window._learnq && data.customer_email) {
          window._learnq.push(['identify', {
            '$email': data.customer_email
          }]);
          
          window._learnq.push(['track', 'Special Event Form Submitted', {
            'customer_name': data.fullname,
            'customer_email': data.customer_email,
            'customer_phone': data.phone_number,
            'number_of_people': data.number_of_people,
            'quantity_of_cupcakes_needed': data.quantity_of_cupcakes_needed,
            'notes': data.notes
          }]);
          
        } else {
          console.warn("Klaviyo _learnq not found or customer email missing");
        }

        isSubmitting = false;
        formObserver.disconnect();
      }
      
      // Check for error messages to reset flag
      const errorElements = shadowRoot.querySelectorAll('[class*="error"], [class*="Error"]');
      if (errorElements.length > 0 && isSubmitting) {
        isSubmitting = false;
      }
    });

    // Observe form container for changes
    const formContainer = shadowRoot.querySelector('#form-container-ref');
    if (formContainer) {
      formObserver.observe(formContainer, {
        childList: true,
        subtree: true,
        attributes: true
      });
    }
  }

  const observer = new MutationObserver(() => {    
    const shopifyFormsEmbed = container.querySelector('shopify-forms-embed');

    if (!shopifyFormsEmbed || !shopifyFormsEmbed.shadowRoot) {
      return;
    }

    const shadowRoot = shopifyFormsEmbed.shadowRoot;
    applyStyles(shadowRoot);
    injectAdditionalButton(shadowRoot);
    watchShopifyForm(shadowRoot);
    observer.disconnect();
  });

  observer.observe(container, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('DOMContentLoaded', injectFormStylesAndButton);

const containerObserver = new MutationObserver(() => {
  const container = document.querySelector('[data-forms-id]');
  if (container) {
    injectFormStylesAndButton();
    containerObserver.disconnect();
  }
});

containerObserver.observe(document.body, {
  childList: true,
  subtree: true
});